import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  _theme => ({
    container: {
      padding: "0 48px"
    }
  }),
  { name: "CouponEditUnlockCodePage" }
);

export default useStyles;
